module.exports = __webpack_public_path__ + "img/warning.3aaa2945.svg";